<template>
    <div>
        <NuxtLayout name="mapa">
            <div class="flex h-full">
                <KlokLeftPanel v-if="!store.mobileMode" />
                <UiSidebar
                    v-if="store.mobileMode"
                    :active="store.mobileLeftPanelOpen"
                    has-manual-drawer-btn
                    direction="from-bottom"
                >
                    <KlokLeftPanel />
                </UiSidebar>
                <div
                    class="relative w-full overflow-clip rounded-md shadow-md md:w-4/5"
                >
                    <LoadingIndicator
                        :active="klokStore.isFetching"
                        class="z-50"
                    />
                    <ClientOnly>
                        <KlokMapView />
                    </ClientOnly>
                    <KlokMetrikaInfoWindow />
                </div>
            </div>
        </NuxtLayout>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()
const klokStore = useKlokStore()
const { t } = useI18n()

const route = useRoute()
const router = useRouter()

useSeoMeta({
    title: "pages.klok",
    ogTitle: () => `${t("pages.klok")} | %siteName`,
})

await callOnce(() => klokStore.fetchSettings())

watch(
    [() => klokStore.selectedLocality, () => klokStore.selectedMetrika],
    () => {
        updateUrlParams()
    }
)

watch(
    () => klokStore.settingsReady,
    () => {
        if (klokStore.settingsReady) {
            setMetrikaFromUrlParams()
        }
    }
)

if (klokStore.settingsReady) {
    setMetrikaFromUrlParams()
}

function setMetrikaFromUrlParams() {
    const params = route.query
    if (params.metrika) {
        const metrika = klokStore.settings?.metriky.find(
            item =>
                item.NAZEV_UDAJE === params.metrika ||
                item.NAZEV_UDAJE_DATA === params.metrika
        )
        if (metrika) {
            klokStore.selectedMetrika = metrika
        }
    }
}

function updateUrlParams() {
    const params: {
        lokalita?: string
        metrika?: string
    } = {}
    if (klokStore.selectedLocality) {
        params.lokalita = klokStore.selectedLocality.CISLO_TXT
    }
    if (klokStore.selectedMetrika) {
        params.metrika = klokStore.selectedMetrika.NAZEV_UDAJE_DATA
    }
    router.push({
        path: route.path,
        query: params,
    })
}
</script>

<style scoped></style>
